// extracted by mini-css-extract-plugin
module.exports = {"slide":"OrderMemberInfo_slide_1QRHQ","slide-reverse":"OrderMemberInfo_slide-reverse_2_qys","OrderMemberInfo":"OrderMemberInfo_OrderMemberInfo_3kAyN"};